export default {
  init() {
    //Menu 
    $('.header__mobile-button').click(function(){
      $(this).toggleClass('active')
      $('.header__mobile-menu').toggleClass('active')
    })

    //Lang switcher
    $(".language-switcher__button").click(function(){
      $(this).find('.language-switcher__language').toggleClass("open")
      $('.language-switcher__dropdown').toggleClass("open")
    })

    //Scroll to top
    $('.go-up__button').click(function(e){
      console.log('kk')
      e.preventDefault()
      $("html,body").animate({ scrollTop: 0 }, 500)
    });

    //Remove p around images
    $('p > img').unwrap();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js